import {RecordForm} from '../forms/RecordForm';
import {useNavigate, useParams} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';
import {useProductLineItem} from '../hooks/useProductLineItem.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {moduleConfig} from "../config";
import {ProductLineItem} from "../types.ts";


export const AddPage = () => {
    const {id: productId} = useParams();
    const navigate = useNavigate();

    if (!productId) {
        throw new Error('productId is required parameter');
    }

    const {
        createRecord,
    } = useProductLineItem(productId);

    // Back to the product once saved; a rejected save keeps the form and its values.
    const handleSubmit = async (values: ProductLineItem) => {
        if (await createRecord(values)) {
            navigate(`/products/${productId}`);
        }
    };

    return (
        <FormPageLayout
            title={`${I18n.get('Add')} ${I18n.get(moduleConfig.titles.singular)}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={{productId, productFeatureId: '', position: 0} as Omit<ProductLineItem, 'id'>}
                        handleSubmit={handleSubmit}/>
        </FormPageLayout>
    );
};
